import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { SlickCarouselStyles } from '../../../styles/molecules/slick-carousel.styles';
import { SlickCarouselImagesProps } from './slick-carousel-images.props';
import LazyLoad from 'react-lazyload';

export const SlickCarouselImagesMolecule = (
  props: SlickCarouselImagesProps
) => {
  const classes = SlickCarouselStyles();
  const defaults = { dotsClass: `${classes.slickDots}` };

  return (
    <Slider {...defaults} {...props.settings}>
      {props.images.map((image: any, index: number) => (
        <div
          key={index}
          className={`focus:outline-none box-border overflow-hidden ${props.addClass}`}
        >
          <LazyLoad offset={100}>
            <img src={image} className="mx-auto outline-none w-full" />
          </LazyLoad>
        </div>
      ))}
    </Slider>
  );
};
